import {AutoProfile} from '@/constants/actionType';
import {FIELD_NAME} from '@/constants/pcConstAppData';

const initialState = {
  showPauseToRefillModal: false,
  isPauseHandled: false,
  runningMethod: FIELD_NAME.CONCENTRATE,
};

export default function autoProfileState(state = initialState, action = {}) {
  switch (action.type) {
    case AutoProfile.SET_SHOW_PAUSE_TO_REFILL_MODAL:
      return {...state, showPauseToRefillModal: action.value};

    case AutoProfile.SET_IS_PAUSE_HANDLED:
      return {...state, isPauseHandled: action.value};

    case AutoProfile.SET_RUNNING_METHOD:
      return {...state, runningMethod: action.value};
    default:
      return state;
  }
}
